import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { getSidebar } from "@/services/Sidebar.service.js";
import { useUserStore } from "@/stores/user.store.ts";

export const useSidebarStore = defineStore("sidebar", () => {
  const sidebarItems = ref([]);
  const branding = ref(null);
  const version = ref(null);
  const loadedCompanyCuid = ref(undefined);
  let refreshSequence = 0;
  const getActiveCompanyCuid = () => useUserStore().user?.company?.cuid ?? null;
  const isLoaded = computed(() => loadedCompanyCuid.value === getActiveCompanyCuid());

  const refresh = async () => {
    const companyCuid = getActiveCompanyCuid();
    refreshSequence += 1;
    const requestSequence = refreshSequence;
    const { data } = await getSidebar();
    if (companyCuid !== getActiveCompanyCuid() || requestSequence !== refreshSequence) {
      return;
    }

    sidebarItems.value = data.sidebar_items;
    branding.value = data.branding;
    version.value = data.version;
    loadedCompanyCuid.value = companyCuid;
  };

  const ensureLoaded = async () => {
    if (!isLoaded.value) {
      await refresh();
    }
  };

  return {
    sidebarItems,
    branding,
    version,
    isLoaded,
    loadedCompanyCuid,
    refresh,
    ensureLoaded,
  };
});
